export function splitMiladiDate(date: Date): string {
  const convertToYYYYMMDD = date?.toString().split('T')[0];
  return convertToYYYYMMDD?.replaceAll('-', '/');
}

export function getShamsiYear(date: Date): number {
  return parseInt(
    date
      .toLocaleDateString('fa-IR', { year: 'numeric' })
      .replace(/([۰-۹])/g, (token) => String.fromCharCode(token.charCodeAt(0) - 1728))
  );
}

/** warning: At the time of use, you should know that it is not completely accurate */
export const minutesUntilMidnight = () => {
  const midnight = new Date();
  midnight.setHours(24);
  midnight.setMinutes(0);
  midnight.setSeconds(0);
  midnight.setMilliseconds(0);
  return (midnight.getTime() - new Date().getTime()) / 1000 / 60;
};

export function addOneYearToDate(date: Date): Date {
  date.setDate(date.getDate() + 365);
  return date;
}

export function addDaysToDate(date: Date, days: number): Date {
  date.setDate(date.getDate() + days);
  return date;
}

export const addOneYear = (date: Date): Date => {
  date.setFullYear(date.getFullYear() + 1);
  return date;
};

export function addMinutes(currentDate: Date, interval: number): Date {
  const newDate = new Date(currentDate);
  newDate.setMinutes(currentDate.getMinutes() + interval);
  return newDate;
}

export function tarikhTavalodValidator(tarikhTavalod: Date | null | undefined): boolean {
  return tarikhTavalod !== undefined && tarikhTavalod !== null;
}

export {};
